const busquedadecontenido = {
    BuscarDocumentos : '/SICPO/BusquedaContenidoMicrositio/GetBusquedaContenidoMicrositio',
 }
 
 export default busquedadecontenido;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/micrositioweb/busquedadecontenido/busquedadecontenido.js
// module id = null
// module chunks = 